import { render, staticRenderFns } from "./a15.vue?vue&type=template&id=2ec01182&scoped=true"
import script from "./a15.vue?vue&type=script&lang=js"
export * from "./a15.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec01182",
  null
  
)

export default component.exports